const getters = {
    disciplines: state => state.Disziplinen,
    bunds: state => state.Bund,
};

export default getters;
